<!-- src/components/LayerPage1.vue -->
<template>
    <div class="whole-container">
      <div class="header">
        <h1> Spatial Transcriptomics (proliferative) </h1>
        <div class="function_description">
          <p> Spatial transcriptome sequencing was performed on one section far away from leiomyoma of fibroid (UM) and three layer-by-layer 6.5mm*6.5mm sections from invaginating site to deep lesion (AM1, AM2, AM3) using the 10x Visium platform. </p>
        </div>
      
    </div>
      <div class="step-one"> <h1 class="custom-h1"><span class="h1-color"># </span><span>Choose the sample</span></h1>
        <div class="sample-container">
          <div class="sample-div">
            <!--
              four samples, each sample has one text name, and two images,
              show name and images.
              when hover on the sample, background color change to blue
              when click on the sample, background color change to black,
              and the sample will be selected.
            -->
            <div v-for="(sample, index) in samples" :key="sample.name" v-bind:id=sample.name class="sample_function1" @mouseover="onMouseover(index)" @mouseleave="onMouseleave(index)" @click="handleSampleClick(index)">
              <div class="sample-name">{{ sample.name }}</div>
              <div class="sample-image">
                <img :src="sample.image1" :alt="'Image ' + (index + 1)" class="indent_image" />
                <img :src="sample.image2" :alt="'Image ' + (index + 1)" class="indent_image" />
              </div>
            </div>
            <div class="indent">
              <img :src="require('../assets/function1_250420/P1_indent.jpg')" class="function1_indent1" />
              <img :src="require('../assets/function1_250420/P2_indent.jpg')" class="function1_indent2" />
            </div>
            <div class="clear"></div>

          </div>
        </div>
      </div>
      <div class="step-two"> 
        <h1 class="custom-h1"><span class="h1-color"># </span><span>Explore the spatial expression, sample expression, and cell type expression of genes</span></h1>
        <div>
            <h2 class="custom-h2"> Enter a gene to explore its spatial distribution characteristics</h2>
            <div class="gene-container">
              <div class="gene-div">
                <input class = "custom-input" v-model="gene" placeholder="Enter a gene" />
                <button class = "custom-button" @click="submitGene_function1_2">Submit</button>
              </div>

            </div>
            <div class="image-container-gene">
          <!-- add an download icon-->
              <div id="wrap">
                <a @click="downloadImage_1_2" class="btn-slide">
                  <span class="circle">
                    <i class="fa fa-download"></i>
                  </span>
                  <span class="title">Download</span>
                  <span class="title-hover">Click here</span>
                </a>
              </div>
              <!-- <button @click="downloadImage" class="download_button">Download</button> -->
              <div class="loading-spinner" v-if="loading"></div>
              <img v-else-if="image1_2" :src="image1_2" alt="Gene Image" class="image"/>
            </div>
        </div>
        <!-- <div>
          <h2> Function 2</h2>
          <div class="xlsx-container">
            <div class="xlsx-div">
              <input v-model="xlsx" placeholder="Enter a xlsx" />
              <button @click="submitXlsx_function2">Submit</button>
            </div>
          </div>
        </div> -->
      <h2 class="custom-h2"> Enter a list of genes (one per line) to explore their expression across samples</h2>
      <FileUpload uniqueId="function_1_2" function_name="function_1_3" v-bind:sample_choose="get_sample_choose"></FileUpload>
      <h2 class="custom-h2"> Enter a list of genes (one per line) to explore their expression across different cell types</h2>
      <FileUpload uniqueId="function_1_3" function_name="function_1_4" v-bind:sample_choose="get_sample_choose"></FileUpload>
      <h2 class="custom-h2"> Enter a list of genes (one per line) to explore their expression in different subpopulations</h2>
      <FileUpload uniqueId="function_1_4" function_name="function_1_5" v-bind:sample_choose="get_sample_choose"></FileUpload>
      </div>
      
      <!-- Your content for Page 1 goes here -->
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { backendIP } from '@/config.js'
  import FileUpload from '@/components/FileUpload.vue';

  export default {
    components: {
      FileUpload,
    },
    name: 'PageOne',
    data() {
      return {
        hovered: false,
        active: false,
        image1_2: null,
        loading: false,
        gene: '', // To store user input
        samples: [
          { name: "UM",image1: require("../assets/function1_250420/P1_UM.jpg"), image2: require("../assets/function1_250420/P2_UM.jpg"), active: false, hovered: false },
          { name: "AM1",image1: require("../assets/function1_250420/P1_AM1.jpg"), image2: require("../assets/function1_250420/P2_AM1.jpg"), active: false, hovered: false },
          { name: "AM2",image1: require("../assets/function1_250420/P1_AM2.jpg"), image2: require("../assets/function1_250420/P2_AM2.jpg"), active: false, hovered: false }, 
          { name: "AM3",image1: require("../assets/function1_250420/P1_AM3.jpg"), image2: require("../assets/function1_250420/P2_AM3.jpg"), active: false, hovered: false },
        ]
      };
    },
    computed: {
      get_sample_choose() {
        let sample_choose = [];
        for (var i = 0; i < this.samples.length; i++) {
          if(this.samples[i].active)
            sample_choose.push(this.samples[i].name);
        }
        return sample_choose;
      },
    },
    methods:{
      handleSampleClick(index){
        this.samples[index].active = !this.samples[index].active;
        //get element by key, set background color to black
        if(this.samples[index].active)
          document.getElementById(this.samples[index].name).style.backgroundColor = "#54bee2";
        else
          document.getElementById(this.samples[index].name).style.backgroundColor = "#ffffff";
        
        
        console.log(this.samples[index].name);
        console.log(this.samples[index].active);
      },
      onMouseover(index){
        this.samples[index].hovered = true;
        if(!this.samples[index].active)
          document.getElementById(this.samples[index].name).style.backgroundColor = "#54bee2";
      },
      onMouseleave(index){
        this.samples[index].hovered = false;
        if(!this.samples[index].active)
          document.getElementById(this.samples[index].name).style.backgroundColor = "#ffffff";
      },
      submitGene_function1_2(){
        let sample_choose = [];
        for (var i = 0; i < this.samples.length; i++) {
          if(this.samples[i].active)
            sample_choose.push(this.samples[i].name);
        }
        if(sample_choose.length == 0)
        {
          alert("Please choose at least one sample");
          return;
        }
        
        if(this.gene == '')
        {
          alert("Please enter a gene name");
          return;
        }

        this.image1_2 = null;

        this.loading = true;

        axios.post(`${backendIP}/function_1_2`, {samplechoose: sample_choose, genechoose: this.gene }, { responseType: 'arraybuffer' })
        .then((response) => {
          // Handle the response, which contains the image data
          this.loading = false;
          console.log(response.headers['content-type'])
          if (response.headers['content-type'] != "image/png") {
            console.error('POST request error', response);
            this.image1_2 = require('../assets/fail.png');
            return;
          }
          const imageBase64 = btoa(
            new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
          );
          this.image1_2 = `data:image/png;base64,${imageBase64}`;
          console.log("set success")
        })
        .catch((error) => {
          // Handle errors, e.g., display an error message
          console.error('POST request error', error);
          this.loading = false;
        });

      },

      downloadImage_1_2() {
        // Use the browser's download functionality, https://stackoverflow.com/a/23797348
        // only can download image when this.image is not null
        if (this.image1_2 == null) {
          return;
        }
        const link = document.createElement('a');
        link.href = this.image1_2;
        link.download = 'figure.png';
        link.click();
      }

      
    }
  }
  </script>

  <style>
  .sample-container{
    margin: 0 auto;
    position: relative;
    width: 90%;
    height: auto;
  }
  .sample_function1{
    width: 20%;
    border: 1px solid #ccc;
    border-radius: 5px;
    text-align: center;
    float: left;
    margin-left: 2%;
  }

  .indent{
    float: left;
    width: 10%;
    margin-top: 20px;
  }

  .sample_function1:hover{
    background-color: #0b536a;
  }

  /* .sample_function1.click{
    background-color: #000000;
  } */

  .indent_image{
    width: 90%;
    margin: 0 5%;
  }

  .function1_indent1{
    width:80%;
    margin: 30% 8%;
  }

  .function1_indent2{
    margin-top: 10%;
    width: 80%;
    margin-left: 8%;

  }

  .step-two{
    clear: both;
    margin: 0 auto;
  }

  /* .image1_2{
    height: 1000px;
  } */

  .image_container1_2{
    height:2000px;
  }

  .clear{
    clear:both;
  }
  </style>
  